import { Component, splitProps } from "solid-js";
import { cleanImagePath } from "./common";

export enum Mode {
    crop = "crop",
    fit = "fit"
}

const heightCache: Record<number, number> = {};
const widthCache: Record<number, number> = {};
const getHeight = (maxWidth: number, width: number, height: number) => {
    const ratio = maxWidth / width;
    const h = Math.floor(height * ratio);
    return h;
};
const getWidth = (maxHeight: number, width: number, height: number) => {
    const ratio = maxHeight / height;
    const w = Math.floor(width * ratio);
    return w;
};

export const Img : Component<any> = (props) => {
    const [local, others] = splitProps(props, ["src", "mode", "w", "h", "width", "height", "format", "maxWidth", "maxHeight", "naturalHeight", "naturalWidth"]);
    let src = local.src;
    let params: string[] = [];
    if (local.mode) params.push("mode=" + local.mode);
    if (local.maxWidth) {
        if (local.naturalWidth && local.naturalHeight) {
            const height = getHeight(local.maxWidth, local.naturalWidth, local.naturalHeight);
            params.push("width=" + local.maxWidth);
            params.push("height=" + height);
        } else {
            params.push("maxWidth=" + local.maxWidth);
        }
    } else if (local.maxHeight ) {
        if (local.naturalWidth && local.naturalHeight) {
            const width = getWidth(local.maxHeight, local.naturalWidth, local.naturalHeight);
            params.push("height=" + local.maxHeight);
            params.push("width=" + width);
        } else {
            params.push("maxHeight=" + local.maxHeight);
        }
    } else {
        if (local.width) params.push("width=" + (local.width || local.w));
        if (local.height) params.push("height=" + (local.height || local.h));
    }
    if (local.format) params.push("format=" + local.format);
    if (params.length) src += "?" + params.join("&");
    return (<img src={cleanImagePath(src)} {...others}></img>);
}